<app-funcionario-modal [isOpen]="isFuncionarioModalOpen" (closeModal)="closeFuncionarioModal($event)"></app-funcionario-modal>

<section class="vendedor-shell">
  <header class="vendedor-hero">
    <div>
      <h2 class="vendedor-title">{{ isEditMode ? 'Editar Vendedor' : 'Novo Vendedor' }}</h2>
      <p class="vendedor-subtitle">Vincule um funcionário ao cadastro de vendedor.</p>
    </div>
    <span class="vendedor-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="vendedorForm" (ngSubmit)="salvar()" id="vendedorForm" class="vendedor-card">
    <div class="form-section">
      <h3>Funcionário Vinculado</h3>
      <div class="row g-3 align-items-end">
        <div class="col-md-8">
          <label class="form-label">Funcionário *</label>
          <input
            type="text"
            class="form-control"
            [value]="nomeFuncionarioCompleto"
            placeholder="Nenhum funcionário selecionado"
            readonly
            [class.is-invalid]="funcionarioInvalido"
          />
          <div class="invalid-feedback" *ngIf="funcionarioInvalido">
            Selecione um funcionário para vincular ao vendedor.
          </div>
        </div>
        <div class="col-md-4">
          <button type="button" class="btn btn-outline-primary w-100" (click)="abrirFuncionarioModal()" [disabled]="isLoading">
            <i class="bi bi-search me-1"></i>
            {{ nomeFuncionarioCompleto ? 'Trocar Funcionário' : 'Selecionar Funcionário' }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Situação</h3>
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="ativo" formControlName="ativo">
        <label class="form-check-label" for="ativo">
          {{ vendedorForm.get('ativo')?.value ? 'Vendedor ativo' : 'Vendedor inativo' }}
        </label>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="vendedorForm" class="btn btn-primary" [disabled]="isLoading">
      {{ isLoading ? 'Salvando...' : 'Salvar' }}
    </button>
  </footer>
</section>
